import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Stack, Chip } from '@mui/material';

// project import
import DrawerHeaderStyled from './DrawerHeaderStyled';
import Logo from 'components/Logo';
import { useState, useEffect } from 'react';
import axios from 'axios';

// ==============================|| DRAWER HEADER ||============================== //

const DrawerHeader = ({ open }) => {
  const theme = useTheme();
  const [version, setVersion] = useState();

  const fetchVersion = async () => {
    const res = await axios.get(process.env.REACT_APP_PYTHIA_API_URL);
    setVersion(res.data.version);
  };
  useEffect(() => {
    fetchVersion();
  }, []);

  return (
    // only available in paid version
    <DrawerHeaderStyled theme={theme} open={open}>
      <Stack direction="row" spacing={1} alignItems="center">
        <Logo />
        {version ? (
          <Chip label={`v${version}`} size="small" sx={{ height: 16, '& .MuiChip-label': { fontSize: '0.625rem', py: 0.25 } }} />
        ) : null}
      </Stack>
    </DrawerHeaderStyled>
  );
};

DrawerHeader.propTypes = {
  open: PropTypes.bool
};

export default DrawerHeader;
